// extracted by mini-css-extract-plugin
export default {"innerWrapper":"aw-z","tooltipWrapper":"bw-z","icon":"cw-z","tooltip":"dw-z","content":"ew-z"};